import React from 'react';
import '../styles/global.css';

const AdminDashboard = () => {
  return (
    <div style={{ paddingTop: 100, paddingBottom: 40 }} className="container">
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 20 }}>
        
        <header style={{ marginBottom: 30, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h1>🚦 Traffic Command Center</h1>
            <p style={{ color: 'var(--text-muted)' }}>Overview of national road infrastructure status.</p>
          </div>
          <div className="glass-panel" style={{ padding: '10px 20px' }}>
            <span style={{ color: 'var(--primary)', fontWeight: 'bold' }}>● System Operational</span>
          </div>
        </header>

        {/* Top Stats Grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: 20, marginBottom: 30 }}>
          <StatCard title="Total Reports" value="12,405" trend="+12% today" color="var(--primary)" />
          <StatCard title="Critical Hazards" value="45" trend="Urgent Action Needed" color="var(--danger)" />
          <StatCard title="Avg. Fix Time" value="4.2 Days" trend="-0.5 days" color="var(--safe)" />
          <StatCard title="Active Users" value="89,200" trend="Live Now" color="var(--warning)" />
        </div>

        {/* Split View */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
          
          {/* Main Chart Area (Mocked) */}
          <div className="glass-panel" style={{ padding: 25, minHeight: 400 }}>
            <h3>Heatmap Analysis</h3>
            <div style={{ 
              marginTop: 20, height: 300, borderRadius: 12, 
              background: 'linear-gradient(180deg, rgba(16,185,129,0.1) 0%, rgba(0,0,0,0) 100%)',
              border: '1px dashed var(--glass-border)',
              display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}>
              [ Interactive Hazard Heatmap Visualization Placeholder ]
            </div>
          </div>

          {/* Priority Queue */}
          <div className="glass-panel" style={{ padding: 25 }}>
            <h3>🚨 Priority Queue</h3>
            <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', gap: 15 }}>
              <QueueItem title="Major Pothole - Mumbai" time="2h ago" priority="High" />
              <QueueItem title="Flooding - Chennai" time="4h ago" priority="Critical" />
              <QueueItem title="Signal Failure - Delhi" time="5h ago" priority="Med" />
              <QueueItem title="Debris - Pune" time="6h ago" priority="Low" />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

const StatCard = ({ title, value, trend, color }) => (
  <div className="glass-panel" style={{ padding: 20 }}>
    <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>{title}</p>
    <h2 style={{ fontSize: '2rem', margin: '10px 0' }}>{value}</h2>
    <span style={{ color: color, fontWeight: 600, fontSize: '0.8rem' }}>{trend}</span>
  </div>
);

const QueueItem = ({ title, time, priority }) => (
  <div style={{ padding: 10, borderBottom: '1px solid var(--glass-border)', display: 'flex', justifyContent: 'space-between' }}>
    <div>
      <div style={{ fontWeight: 600 }}>{title}</div>
      <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{time}</div>
    </div>
    <span style={{ color: priority === 'Critical' ? 'var(--danger)' : 'var(--warning)', fontSize: '0.8rem' }}>{priority}</span>
  </div>
);

export default AdminDashboard;